import Platform from './vendor/qnbar/platform.js'

var PT = new Platform.Platform();
PT.config.env = "local";  //local test release
PT.config.hostBaseUrl = 'http://agent.local.qnbar.cn/';  //当前页面访问环境的host base
PT.config.platformUsagespace = 'PT_AGENT_BZ';  //平台标记，固定需要，qnapi的请求要带上 【后端给具体定义】
PT.config.apiBaseUrl = 'https://api2.qnbar.cn/';  //后端服务api 访问基本地址 例如 https://api2.qnbar.com
PT.config.qnloginBaseUrl = "http://passport.t.qnbar.cn/";   //passport统一登录服务web的基本地址
PT.config.qnloginPlatformNo = 8;   //passport统一登录的注册平台号
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl); //passport统一登录的登录成功固定回跳地址
PT.config.wsHost = "ws.qnbar.cn";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();
export default {
    PT : PT
}


// WEBPACK FOOTER //
// ./src/env.local.js